module.exports = __webpack_public_path__ + "static/media/BTCUSDT.6640f6c9.png";